module.exports = __webpack_public_path__ + "static/media/arrow.bff74871.svg";